import { apiGet } from "./client";
import { ApiConfig } from "./config";

/**
 * Build a query string from the provided params map, excluding null/empty values.
 * Returns an empty string when no valid params remain.
 * Example: buildQueryString({ page: 2, query: "john" }) => "?page=2&query=john"
 */
export const buildQueryString = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string" && value.trim() === "") return false;
    return true;
  });

  if (entries.length === 0) {
    return "";
  }

  const search = new URLSearchParams();
  entries.forEach(([key, value]) => {
    search.append(key, value);
  });

  const queryString = search.toString();
  return queryString ? `?${queryString}` : "";
};

/**
 * Retrieves a list of all provinces from the backend.
 */
export async function getProvinceList() {
  return apiGet(`${ApiConfig.LOCATION_BASE}/provinces/`);
}

/**
 * Retrieves a list of all districts from the backend.
 */
export async function getDistrictList(queryParam) {
  const queryString = buildQueryString({ province_code: queryParam });
  return apiGet(`${ApiConfig.LOCATION_BASE}/districts/${queryString}`);
}

/**
 * Retrieves a list of all sub-districts from the backend.
 */
export async function getSubdistrictList(queryParam) {
  const queryString = buildQueryString({ district_code: queryParam });
  return apiGet(`${ApiConfig.LOCATION_BASE}/sub-districts/${queryString}`);
}